module.exports = __webpack_public_path__ + "img/teacher_qun.09dbe5fe.png";